import { render, staticRenderFns } from "./PresupuestoVentas.vue?vue&type=template&id=23d3719e"
import script from "./PresupuestoVentas.vue?vue&type=script&lang=js"
export * from "./PresupuestoVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports